module.exports = __webpack_public_path__ + "img/icon_charity.ce0fa0ca.ba622251.svg";